<template>
  <div class="ht-container ht-container-admin pb-5">
    <div class="box pt-2 pl-2 pr-2">
      <h4 class="mt-3">Activity Feed</h4>
      <div class="p-2 row border-bottom">
        <span class="col-1 text-center">
          <i class="fas fa-thermometer-half text-muted"></i>
        </span>
        <span class="col-8 text-left">
          The temperature in the house dropped 10 degrees in the last hour. Is this expected?
        </span>
        <span class="col-3 text-muted text-right small">
          4 hours ago
        </span>
      </div>
      <div class="p-2 border-bottom row">
        <span class="col-1 text-center">
          <i class="far fa-map text-muted"></i>
        </span>
        <span class="col-8 text-left">
          Dana has arrived at home.
        </span>
        <span class="col-3 text-muted text-right small">
          4 hours ago
        </span>
      </div>
      <div class="p-2 border-bottom row">
        <span class="col-1 text-center">
          <i class="ml-2 mr-3 far fa-bell text-muted"></i>
        </span>
        <span class="col-8 text-left">
          Kevin added a new chore for Aidan.
        </span>
        <span class="col-3 text-muted text-right small">
          6 hours ago
        </span>
      </div>
      <div class="p-2 border-bottom row">
        <span class="col-1 text-center">
          <i class="ml-2 mr-3 fas fa-broom text-muted"></i>
        </span>
        <span class="col-8 text-left">
          Aidan completed a chore: brush teeth.
        </span>
        <span class="col-3 text-muted text-right small">
          6 hours ago
        </span>
      </div>
      <div class="p-2 border-bottom row">
        <span class="col-1 text-center">
          <i class="ml-2 mr-3 far fa-map text-muted"></i>
        </span>
        <span class="col-8 text-left">
          Dana left home.
        </span>
        <span class="col-3 text-muted text-right small">
          7 hours ago
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class ManageDashboard extends Vue {

}
export default ManageDashboard;
</script>

<style scoped>

.box {
  display: flex;
  flex-direction: column;
  flex-basis: 70%;
  flex-shrink: 1;
  flex-grow: 1;
  background-color: #fff;
  text-align: center;
}

.box > h4 {
  margin: 1.25rem 0 .5rem;
  font-size: .75rem;
  text-transform: uppercase;
  color: #5c6072;
  font-weight: 400;
  line-height: 1.2;
}

</style>
